import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useContext, useEffect, useMemo, useState } from 'react';
// Temporary fix to enable the Growth team’s app recommendation section to access our experiment.
// TODO: https://hello.jira.atlassian.cloud/browse/NAVX-350
var storageKey = '@atlassian/switcher-team-25-experiment-cohort';
export var ExperimentContext = /*#__PURE__*/React.createContext(undefined);
export var SwitcherExperimentProvider = function SwitcherExperimentProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    switcherTeam25ExperimentCohort = _useState2[0],
    setSwitcherTeam25ExperimentCohort = _useState2[1];
  var contextValue = useMemo(function () {
    return {
      switcherTeam25ExperimentCohort: switcherTeam25ExperimentCohort,
      setSwitcherTeam25ExperimentCohort: setSwitcherTeam25ExperimentCohort
    };
  }, [switcherTeam25ExperimentCohort, setSwitcherTeam25ExperimentCohort]);
  useEffect(function () {
    var _window;
    if ((_window = window) !== null && _window !== void 0 && _window.sessionStorage && switcherTeam25ExperimentCohort) {
      window.sessionStorage.setItem(storageKey, switcherTeam25ExperimentCohort);
    }
  }, [switcherTeam25ExperimentCohort]);
  return /*#__PURE__*/React.createElement(ExperimentContext.Provider, {
    value: contextValue
  }, children);
};
export var useExperimentProvider = function useExperimentProvider() {
  return useContext(ExperimentContext);
};
export var useSwitcherTeam25Experiment = function useSwitcherTeam25Experiment() {
  var experimentContext = useExperimentProvider();
  return {
    cohort: experimentContext === null || experimentContext === void 0 ? void 0 : experimentContext.switcherTeam25ExperimentCohort,
    setCohort: experimentContext ? experimentContext.setSwitcherTeam25ExperimentCohort : function () {}
  };
};
export var useIsSwitcherTeam25TestCohort = function useIsSwitcherTeam25TestCohort() {
  var _window2;
  var _useSwitcherTeam25Exp = useSwitcherTeam25Experiment(),
    cohort = _useSwitcherTeam25Exp.cohort;
  if (cohort) {
    return cohort === 'test';
  }

  // fallback to session storage
  return ((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.sessionStorage) === null || _window2 === void 0 ? void 0 : _window2.getItem(storageKey)) === 'test';
};